import { render, staticRenderFns } from "./Oj.vue?vue&type=template&id=60839296&"
import script from "./Oj.vue?vue&type=script&lang=ts&"
export * from "./Oj.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports